import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-desktop-sidebar',
  templateUrl: './common-desktop-sidebar.component.html',
  styleUrls: ['./common-desktop-sidebar.component.scss']
})
export class CommonDesktopSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
